<style scoped lang="less">
.protocol {
  width: 100%;
  height: 500px;
  position: relative;
  background-image: url("http://cdn-cus.weixinhai.net/cdn/web/img/bg.8a1fb91c.png");
  background-size: 100% 100%;
  //background: linear-gradient(0deg, #E2ECF5 0%, #FFFFFF 100%);
}

.pro-container {
  width: 1200px;
  margin: 0 auto;
  padding-top: 80px;
  //padding-bottom: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.pro-title {
  font-size: 36px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  line-height: 32px;
}

.pro-line {
  margin-top: 24px;
  width: 40px;
  height: 4px;
  background: #2365D3;
}

.info-line {
  margin-top: 30px;
  width: 16px;
  height: 1px;
  background: #333333;
}

.info-content {
  box-shadow: 0px 5px 21px 0px #E4ECF2;
  border-radius: 4px;
  width: 93%;
  padding: 70px 20px 80px 20px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin-top: 70px;
  background: white;

  .info-top {
    display: flex;
    flex-direction: row;
    align-items: start;
    justify-content: space-around;
    flex-wrap: wrap;
  }

  .info-endline {
    width: 1px;
    height: 255px;
    background: #EEEFF3;
  }

  .info-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    .info-icon {
      width: 80px;
      height: 80px;
    }
    .info-text {
      margin-top: 20px;
      width: 80px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
      text-align: center;
    }

    .info-arrow {
      cursor: pointer;
      margin-top: 70px;
      width: 35px;
      height: 7px;
    }

    .info-round {
      cursor: pointer;
      margin-top: 70px;
      width: 6px;
      height: 6px;
      background: #000000;
      border-radius: 50%;
    }

    .info-round:hover {
      width: 35px;
      height: 7px;
      background-color: #fff;
      border-radius: 0;
      background-image: url('../assets/image/info/arrow-right.png');
      background-size: 100% 100%;
    }
  }
  .info-bottom {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
  }
}

@media (max-width: 1200px) {
  .pro-container {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .protocol {
    height: 1100px;
  }

  .pro-container {
    width: 80%;
    padding-top: 60px;
    padding-bottom: 60px;

    .info-content {
      //width: 80%;
      .info-endline {
        width: 1px;
        height: 225px;
        background: #EEEFF3;
      }

      .lin-s {
        height: 0;
      }
    }

    .info-list {
      margin-top: 40px;

      .info-text-four {
        margin-top: 34px;
      }

      .info-round {
        margin-top: 40px;
      }
    }

    .info-text {
      text-align: center;
    }
  }

  .pro-title {
    font-size: 28px;
  }
}
</style>
<template>
  <div class="protocol" id="infoId">
    <div class="pro-container">
      <!--      标题-->
      <p :class="['pro-title', {'animated fadeInUp': flag}]">{{ $t('Info.title') }}</p>
      <div class="pro-line"></div>
      <!--      内容部分-->
      <div class="info-content">
        <div class="info-top">
          <div class="info-list">
            <img class="info-icon" src="../assets/image/info/icon1.png"/>
            <div class="info-text">{{ $t('Info.infos.scenario') }}</div>
            <!--            <div class="info-line"></div>-->
            <!--            <div  class="info-round"></div>-->
          </div>
          <!--        <div class="info-endline"></div>-->
          <div class="info-list">
            <img class="info-icon" src="../assets/image/info/icon2.png"/>
            <div class="info-text">{{ $t('Info.infos.marketing') }}</div>
            <!--          <div class="info-line"></div>-->
            <!--          <div  class="info-round"></div>-->
          </div>
          <!--        <div class="info-endline line-s"></div>-->
          <div class="info-list">
            <img class="info-icon" src="../assets/image/info/icon3.png"/>
            <div class="info-text">{{ $t('Info.infos.enterprise') }}</div>
            <!--          <div class="info-line"></div>-->
            <!--          <div  class="info-round"></div>-->
          </div>
          <!--        <div class="info-endline"></div>-->
          <div class="info-list">
            <img class="info-icon" src="../assets/image/info/icon4.png"/>
            <div class="info-text info-text-four">{{ $t('Info.infos.artificial') }}</div>
            <!--          <div class="info-line"></div>-->
            <!--          <div  class="info-round"></div>-->
          </div>
          <!--        <div class="info-endline lin-s"></div>-->
          <div class="info-list">
            <img class="info-icon" src="../assets/image/info/icon5.png"/>
            <div class="info-text">{{ $t('Info.infos.integral') }}</div>
            <!--          <div class="info-line"></div>-->
            <!--          <div  class="info-round"></div>-->
          </div>
          <!--        <div class="info-endline"></div>-->
          <div class="info-list">
            <img class="info-icon" src="../assets/image/info/icon6.png"/>
            <div class="info-text" style="width: 97px">{{ $t('Info.infos.service') }}</div>
            <!--          <div style="margin-top: 50px" class="info-line"></div>-->
            <!--          <div  class="info-round"></div>-->
          </div>
        </div>
<!--        <div class="info-bottom">-->
<!--        <div class="info-line"></div>-->
<!--        <div class="info-line"></div>-->
<!--        <div class="info-line"></div>-->
<!--        <div class="info-line"></div>-->
<!--        <div class="info-line"></div>-->
<!--      </div>-->
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'Protocol.vue',
  data() {
    return {
      flag: true
    }
  },
  mounted() {
  },
  destroyed() {
  }
}
</script>
